import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackUpdatedNotificationPreference.meta';

type NotificationSetting =
  | 'New comments on assets in followed boards'
  | 'Mentions on assets'
  | "Replies in threads you've started or are in"
  | 'Subboard creations in followed boards'
  | 'Items uploaded to followed boards'
  | 'Custom field changes in followed boards'
  | 'Views of links you created'
  | 'Downloads from links you created'
  | 'Comments on links you created'
  | 'Submissions to content collection forms you created'
  | 'Custom field changes made on links you created'
  | 'Expiring or expired links you created';

type TrackUpdatedNotificationPreferenceParams = {
  setting: NotificationSetting;
  type: 'email' | 'in-app';
  value: boolean;
};

export const useTrackUpdatedNotificationPreference = () => {
  const { track } = useAnalyticsUtilities();

  const trackUpdatedNotificationPreference = useCallback(
    (params: TrackUpdatedNotificationPreferenceParams) => {
      track(META.name, params);
    },
    [track],
  );
  return {
    trackUpdatedNotificationPreference,
  };
};
